import { CardContent, SelectField, TextField } from '@/components'
import type { TrialSignUp } from '../../hooks/useTrialSignUp'
import { useAuthMutating } from '../../stores'
import { ACCOUNT_TYPES, AccountTypeToggle } from '../AccountTypeToggle'
import { FirmNameField } from '../FirmNameField'
import { PaymentTrust } from '../PaymentTrust'
import { TermsCheckbox } from '../TermsCheckbox'
import { NameFields } from './NameFields'
import { TrialSubmit } from './TrialSubmit'

const ROLE_OPTIONS = [
  { value: 'attorney', label: 'Attorney' },
  { value: 'paralegal', label: 'Paralegal' },
  { value: 'forensic_accountant', label: 'Forensic accountant' },
  { value: 'other', label: 'Other' },
]

type InputChange = React.ChangeEvent<HTMLInputElement>

interface TrialSignUpFormProps {
  trial: TrialSignUp
}

export const TrialSignUpForm = ({ trial }: TrialSignUpFormProps) => {
  const { data, errors, setFieldValue } = trial.form
  const isSendingCode = useAuthMutating()
  const accountType = (data.accountType as string) ?? ACCOUNT_TYPES.firm
  const isFirm = accountType === ACCOUNT_TYPES.firm

  return (
    <CardContent className="px-4 sm:px-6">
      <form onSubmit={trial.submitDetails} className="space-y-4">
        <AccountTypeToggle value={accountType} setFieldValue={setFieldValue} />
        <NameFields form={trial.form} />
        {isFirm && (
          <FirmNameField
            label="Firm name"
            placeholder="Type your firm name"
            helpText=""
            defaultValue={data.accountName as string}
            error={errors.accountName}
            setFieldValue={setFieldValue}
          />
        )}
        <TextField
          label="Email address"
          id="email"
          type="email"
          placeholder="Type your email address"
          autoComplete="email"
          helpText="You will receive a 6-digit code to confirm your email address."
          value={(data.email as string) ?? ''}
          error={errors.email}
          onChange={(e: InputChange) => setFieldValue('email', e.target.value)}
          required
        />
        {isFirm && (
          <SelectField
            id="role"
            label="What is your role? (optional)"
            placeholder="Choose a role"
            options={ROLE_OPTIONS}
            value={(data.role as string) ?? ''}
            onValueChange={(role) => setFieldValue('role', role)}
          />
        )}
        <TermsCheckbox
          value={data.terms as boolean}
          setFieldValue={setFieldValue}
          isMutating={isSendingCode}
          className="pt-2"
        />
        <TrialSubmit trial={trial} isSendingCode={isSendingCode} />
        <PaymentTrust />
      </form>
    </CardContent>
  )
}
